import React from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";

const DatasetFilter = ({
  Show,
  Hide,
  Title,
  buttonFiletrLoader
}) => {
 
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={buttonFiletrLoader}
            className="updateProfile"
          >
            {buttonFiletrLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Filtering...
              </div>
            ) : (
              "Filter"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default DatasetFilter;
